import { GraphPoint } from './../../../../logic/graphql/types/types.d';
import { ScreenSize } from '../../../../styles/screen-sizes';

export const calculateGraphRangeData = (
  points: GraphPoint[],
): { rangeMin: number; rangeMax: number; ticks: number[] } => {
  let min = Infinity;
  let max = 0;
  points.forEach((d) => {
    if (d.value < min) {
      min = d.value;
    }
    if (d.value > max) {
      max = d.value;
    }
  });

  const extension = (max - min) * 0.2;
  const rangeMin = min - extension;
  const rangeMax = max + extension;

  const ticks: number[] = [];
  ticks.push(min);
  for (let i = 1; i < 5; i++) {
    ticks.push(min + ((max - min) * i) / 5);
  }
  ticks.push(max);

  return { rangeMin, rangeMax, ticks };
};

export const calculateXAxisProperties = (
  screenSize: ScreenSize,
  numberOfPoints: number,
): {
  textAnchor?: string;
  tick?: { angle: number };
  interval?: number;
  dy?: number;
} => {
  if (screenSize === ScreenSize.XS) {
    return {
      textAnchor: 'start',
      tick: { angle: 45 },
      interval: Math.min(numberOfPoints, Math.floor(numberOfPoints / 8)),
    };
  } else if (screenSize === ScreenSize.SM) {
    return {
      textAnchor: 'start',
      tick: { angle: 45 },
      interval: Math.min(numberOfPoints, Math.floor(numberOfPoints / 14)),
    };
  }

  return {
    dy: 10,
  };
};
